import ReactDOM from "react-dom/client";
import AdminAppWrapper from "./AdminAppWrapper";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<AdminAppWrapper />);
